import { LocalizedString } from './localized';

export enum PlatformType {
  Mobile = 'MOBILE',
  Tablet = 'TABLET',
  Web = 'WEB',
  BigScreen = 'BIGSCREEN',
}

export interface ImageUrlsByPlatform {
  platform: PlatformType;
  imageUrl: string;
}

export interface LocalizedImageUrlsByPlatform {
  platform: PlatformType;
  imageUrl: LocalizedString;
}
